import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";

import AsiacellService from "./../../../Utilies/Utilies/AsiacellService";
import logo from "./../../../assets/imgs/logo2.32a2f0e40fc629cb6e51.png";
import Layout from "../../../Components/layout";
import grandLogo from "./../../../assets/imgs/grandLogo.png";
import { useTranslation } from "react-i18next";

export default function IraqConfirm() {
     const { i18n, t } = useTranslation();
     useEffect(() => {
        document.body.dir = i18n.dir();
      }, [i18n, i18n.language]);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // State variables (same names as Angular for easier migration)
  const [showloading, setShowloading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [headerData, setHeaderData] = useState({});
  const [enriched, setEnriched] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [errorMesg, setErrorMesg] = useState(false);
  const [errorMesgSubscribe, setErrorMesgSubscribe] = useState("");

  useEffect(() => {
    const qUniqid = searchParams.get("uniqid");
    if (qUniqid != null && String(qUniqid).trim() !== "") {
      try {
        localStorage.setItem("AntiFrauduniqid", String(qUniqid));
      } catch (e) {
        /* ignore */
      }
    }
    fetchHeader();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- bootstrap once from URL then header
  }, []);

  const fetchHeader = async () => {
    try {
      const data = await AsiacellService.getPhoneByHeader();
      setHeaderData(data);

      if (data.Msisdn) {
        headerSignup(data);
      }
    } catch (err) {
      console.error("Error fetching header:", err);
    }
  };

  const isAntiFraudAvailable = () => {
    return !!localStorage.getItem("AntiFrauduniqid");
  };

  const headerSignup = async (headerData) => {
    const body = {
      headers: headerData.Headers,
      msisdn: headerData.Msisdn,
      pageid: "2",
    };

    try {
      const res = await AsiacellService.getScript(body);

      if (res) {
        const script = document.createElement("script");
        script.innerHTML = res.data.message;
        document.head.appendChild(script);

        localStorage.setItem("AntiFrauduniqid", res.data.AntiFrauduniqid);

        setEnriched(true);
        setShowLoading(false);
      } else {
        setErrorMesg(true);
        setErrorMesgSubscribe(res.message);
      }
    } catch (err) {
      console.log("Error:", err);
    }
  };

  const confirmSubscribe = async () => {
    setShowloading(true);
    setShowError(false);
    setErrorMessage("");

    const body = {
      phone: headerData.Msisdn,
      AntiFrauduniqid: localStorage.getItem("AntiFrauduniqid"),
      company: localStorage.getItem("trafficsource"),
      key: localStorage.getItem("parameter"),
    };
     
    try {
      const res = await AsiacellService.confirmSubscribe(body);

      if (res.success) {
        localStorage.setItem("phone", headerData.Msisdn);
        navigate("/success?status=200");
      } else {
        setShowloading(false);
        setShowError(true);
        setErrorMessage(res.message || "حدث خطأ ما، يرجى المحاولة مرة أخرى.");
      }
    } catch (err) {
      setShowloading(false);
      setShowError(true);
      setErrorMessage("حدث خطأ ما، يرجى المحاولة مرة أخرى.");
    }
  };

  return (
    <>
    <Layout reloadOnLanguageChange>
      <div className="container my-5 ">
           <div className="row d-flex justify-content-center mt-2">
                   <img className="servImg" src={logo} alt="" />
              </div>

              <div className="fw-bold text-center my-2" style={{ color: "red" }}>
            <h3>{t("free_days_title")}</h3>
          </div>
        {showError && (
          <div
            className="alert alert-danger text-center"
            style={{ fontSize: "18px", fontWeight: "bold" }}
          >
            {errorMessage}
          </div>
        )}

        {/* Confirm Button */}
        <div className="d-flex justify-content-center mt-4">
          <button
            onClick={confirmSubscribe}
            disabled={showloading}
            className="btn btn-primary px-4 py-2 rounded-pill w-100 text-center "
          >
      {showloading ? t("loading_subscribe") : t("confirm_subscribe")}
          </button>
        </div>
  <div className="text-center mt-2">
          <p style={{ direction: "rtl", fontWeight: "500" }} className="px-4">
  {t("description")}
</p>


            <p style={{ direction: "rtl" }} className="px-4 ">
              {t("terms_prefix")}{" "}
              <Link className="text-decoration-none" to="/aciq-terms-and-conditions">
                {t("terms_link")}
              </Link>
            </p>
          </div>

              {/* Footer Image */}
              {/* <div className="d-flex justify-content-center">
                   <img className="" src={grandLogo} alt="" />
              </div> */}
        {/* Additional error */}
        {errorMesg && (
          <p className="text-danger text-center mt-3">{errorMesgSubscribe}</p>
        )}
      </div>
      </Layout>
    </>
  );
}
